import { StateNameEnum } from '@base/store/state-name.enum';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './reducer';

const state_selector = createFeatureSelector<fromReducer.State>(StateNameEnum.core_user);
export const currentUserContext = createSelector(state_selector, (state: fromReducer.State) => state.currentUserContext);
export const employeeInfo = createSelector(state_selector, (state: fromReducer.State) => state.employeeInfo);

